import { render, staticRenderFns } from "./email.vue?vue&type=template&id=29cda028&scoped=true&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&id=29cda028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cda028",
  null
  
)

component.options.__file = "email.vue"
export default component.exports